import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IconsModule} from '../../icons/icons.module';
import {RouterModule} from '@angular/router';
import {DepartmentsComponent} from './departments.component';
import { MultiCountryCurrencyModule } from '../../../pipes/multi-country-currency/multi-country-currency.module';
import { PrimeFlagModule } from '../prime-flag/prime-flag.module';

@NgModule({
  declarations: [
    DepartmentsComponent,
  ],
  imports: [CommonModule, IconsModule, RouterModule, MultiCountryCurrencyModule, PrimeFlagModule],
  exports: [
    DepartmentsComponent
  ]
})
export class DepartmentsHeaderModule {}
